import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { redirectIfAuthenticatedGuard } from '@cfg-guards/auth-redirect/auth-redirect.guard';
import { AuthGuard } from '@cfg-guards/authentication/authentication.guard';

const routes: Routes = [
  {
    path: 'sign-in',
    loadChildren: () => import('./sign-in/sign-in.module').then(m => m.SignInModule),
    canActivate: [redirectIfAuthenticatedGuard],
    canMatch: [redirectIfAuthenticatedGuard],
  },
  { path: 'sign-up', loadChildren: () => import('./sign-up/sign-up.module').then(m => m.SignUpModule) },
  { path: 'password-recovery', loadChildren: () => import('./password-recovery/password-recovery.module').then(m => m.PasswordRecoveryModule) },
  {
    path: 'profile',
    canActivate: [AuthGuard],
    canMatch: [AuthGuard],
    loadChildren: () => import('./profile/profile.module').then(m => m.ProfileModule)
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthenticationRoutingModule { }
